<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <Listbox as="div" v-model="selected" @click="update()">
    <div class="relative">
      <div class="inline-flex shadow-sm rounded-md divide-x divide-blue-600">
        <div class="relative z-0 inline-flex shadow-sm rounded-md divide-x divide-blue-600">
          <div class="relative inline-flex items-center bg-blue-800 py-2 pl-3 pr-4 border border-transparent rounded-l-md shadow-sm text-white">
            <CheckIcon class="h-5 w-5" aria-hidden="true" />
            <p class="ml-2.5 text-sm font-medium">{{ $t(`tickets_form.${replaceSpace(selected.title).toLowerCase()}_dropdown`) }} </p>
          </div>
          <ListboxButton class="relative inline-flex items-center bg-blue-900 p-2 rounded-l-none rounded-r-md text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus:z-10 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-sky-500">
            <ChevronDownIcon class="h-5 w-5 text-white" aria-hidden="true" />
          </ListboxButton>
        </div>
      </div>

      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <ListboxOptions class="-top-2 transform -translate-y-full absolute right-0 w-56 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <ListboxOption as="template" v-for="option in data" :key="option.title" :value="option" >
            <li :class="[option.selected ? 'text-white bg-blue-600' : 'text-gray-900', 'cursor-default select-none relative p-4 text-sm']">
              <div class="flex flex-col">
                <div class="flex justify-between">
                  <p :class="selected ? 'font-semibold' : 'font-normal'">
                    {{ $t(`tickets_form.${replaceSpace(option.title).toLowerCase()}_response`) }}
                  </p>
                  <span v-if="selected" :class="option.selected ? 'text-white' : 'text-sky-500'">
                    <CheckIcon v-if="option.selected" class="h-5 w-5" aria-hidden="true" />
                  </span>
                </div>
                <p :class="[option.selected ? 'text-sky-200' : 'text-gray-500', '']">
                {{ $t(`tickets_form.${replaceSpace(option.title).toLowerCase()}_description`) }}
                </p>
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>

import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/24/solid'


export default {
  props: {
      label: String,        
      value: [String, Object, Boolean],
  },  

  data() {
    return {
      selected: {},
      data: [
        {
          title: 'Public',
          value: 'public',
          selected: true,
        },
        {
          title: 'Private',
          value: 'private',
          selected: false,
        },
      ],
    }
  },
  methods: {
    update(){
      
      for(let i = 0; i < this.data.length; i++){
        
        if(this.data[i].value === this.value){        
          this.data[i].selected = true;
          this.selected = this.data[i];
        }
        else{
          this.data[i].selected = false;
        }
      } 
      
      this.$emit('update:modelValue', this.selected.value);
    },  
    replaceSpace(string){
        // remove , . - 
        string = string.replace(/[,.-]/g, "");
        return string.replace(/ /g, '_');
    }      
  },  

  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronDownIcon,
  },

  watch: {
    value: function (val) {
      this.update();
    },
  },

  created() {
    this.selected = this.data[0]
    this.update();
  },
  
}
</script>



<!-- Open top -->
<!-- -top-2 transform -translate-y-full absolute right-0 w-56 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none -->
<!-- Open bottom -->
<!-- origin-top-right absolute z-10 right-0 mt-2 w-72 rounded-md shadow-lg overflow-hidden bg-white divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none --> 